const iterateConfirmationHooks = async (hooks, ...args) => {
  for (const hook of hooks) {
    try {
      const result = await hook(...args);
      if (result !== null) {
        return result === true;
      }
    } catch (e) {
      console.trace("Exception occurred in deletion confirmation hook: ", e);
    }
  }
  return null;
};
export default iterateConfirmationHooks;
